import moment from 'moment';

export const generalKey = 'product_sp_400w_solar_panel';
export const whiteLocaleList = ['us', 'ca']; //白名单
export const productPageUrl = 'delta-3-series';
export const tabsValues: string[] = [];
export const productPageTheme = 'black'; //主题色

export const emailConfig: Record<
    string,
    {
        contactListId: string[];
        fields: {
            id: string;
            overwrite: boolean;
            type: string;
            value: string | string[] | number;
        }[];
    }
> = {
    us: {
        contactListId: ['1309693895'],
        fields: [
            {
                id: '4423',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '31',
                overwrite: false,
                type: 'single',
                value: 1,
            },
            {
                id: '13680',
                overwrite: false,
                type: 'text',
                value: moment(new Date()).format('YYYY-MM-DD'),
            },
            {
                id: '11150',
                overwrite: false,
                type: 'multiple',
                value: ['29'],
            },
        ],
    },
    ca: {
        contactListId: ['1525424752'],
        fields: [
            {
                id: '4424',
                overwrite: true,
                type: 'single',
                value: 1,
            },
            {
                id: '31',
                overwrite: false,
                type: 'single',
                value: 1,
            },
            {
                id: '13680',
                overwrite: false,
                type: 'text',
                value: moment(new Date()).format('YYYY-MM-DD'),
            },
            {
                id: '11150',
                overwrite: false,
                type: 'multiple',
                value: ['29'],
            },
        ],
    },
};

export enum productType {
    D3U = 'd3u',
    D3UP = 'd3up',
    D3M = 'd3m',
    D3MP = 'd3mp',
    D3C = 'd3c',
}

export const learnMoreLink: Record<productType, string> = {
    d3u: '/delta-3-ultra-plus-portable-power-station',
    d3up: '/delta-3-ultra-plus-portable-power-station',
    d3m: '/delta-3-max-plus-portable-power-station',
    d3mp: '/delta-3-max-plus-portable-power-station',
    d3c: '/delta-3-classic-portable-power-station',
};

export const variantId: Record<string, Record<productType, string>> = {
    us: {
        d3u: '54692148871241',
        d3up: '54718705008713',
        d3m: '54692162764873',
        d3mp: '54718699962441',
        d3c: '54691871227977',
    },
    ca: {
        d3u: '62060629590387',
        d3up: '62106740556147',
        // d3m: '62060638372211',
        d3m: '62531792994675',
        d3mp: '62106661618035',
        d3c: '62060639584627',
    },
};

export const shopNowLink: Record<string, Record<productType | 'nav', string>> = {
    us: {
        nav: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54692162764873',
        d3up: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54692157882441',
        d3u: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54692148871241',
        d3mp: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441',
        d3m: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54692162764873',
        d3c: 'https://us.ecoflow.com/products/delta-3-classic-portable-power-station?variant=54691871227977',
    },
    ca: {
        nav: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62060638372211',
        d3up: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62060632080755',
        d3u: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62060629590387',
        d3mp: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62106661618035',
        d3m: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62531792994675',
        d3c: 'https://ca.ecoflow.com/products/delta-3-classic-portable-power-station?variant=62060639584627',
    },
};
